import React, { useEffect, useRef, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { Form, FormikProvider, useFormik } from 'formik'
import { Container } from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { AC_YEAR_OLD } from '../../CommonUtils/contextVariables';

export default function FfcaCollegeCourseDetails2021() {
  const userId = sessionStorage.getItem('user_id').split('ffca_')[1];
  const acYear = sessionStorage.getItem('ac_year');
  const hasFetchedData = useRef(false);
  const affclgcourseDtlsFormik = useFormik({
    initialValues: {
      collCode: userId,
      acYear: acYear,

    },
    onSubmit: (values) => {

    }
  })
  const [existingCourses, setExistingCourses] = useState([]);
  function GetExistingCoursesData() {
    let url = config.url.API_URL + `getExistingCourses`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        const courses = res?.data?.getExistingCourses || [];
        setExistingCourses(courses)

      } else {
        setExistingCourses([]);
      }
    })
  }



  const [additionalSecData, setAdditionalSecData] = useState([]);

  function GetAdditionalCourseDtls() {
    let url = config.url.API_URL + `getadditionalSections`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        const courses = res?.data?.getadditionalSections || [];
        setAdditionalSecData(courses)

      } else {
        setAdditionalSecData([]);
      }
    })
  }






  const [additionaNewCourseData, setAdditonNewCourseData] = useState([]);

  function GetAddNewCourseData() {
    let url = config.url.API_URL + `getadditionalNewCourse`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        const courses = res?.data?.getadditionalNewCourse || [];
        setAdditonNewCourseData(courses)

      } else {
        setAdditonNewCourseData([]);
      }
    })
  }

  const [perminantCourseData, setPerminantCourseData] = useState([]);
  function GetPermanentCourse() {
    let url = config.url.API_URL + `getpermanentAfflFfcaCourses`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        const courses = res?.data?.getpermanentAfflFfcaCourses || [];
        setPerminantCourseData(courses)

      } else {
        setPerminantCourseData([]);
      }
    })
  }




  const [withDrawCourseData, setWithDrawCourseData] = useState([]);
  function GetWithdrawCourses() {
    let url = config.url.API_URL + `getwithdrawlCourses`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        const courses = res?.data?.getwithdrawlCourses || [];
        setWithDrawCourseData(courses)

      } else {
        setWithDrawCourseData([]);


      }
    })
  }

  useEffect(() => {
    if (!hasFetchedData.current) {
      GetExistingCoursesData();
      GetAdditionalCourseDtls();
      GetAddNewCourseData();
      GetPermanentCourse();
      GetWithdrawCourses();

      hasFetchedData.current = true
    }

  }, [])



  const CourseDetailsColumns = [
    {
      Header: 'Sl.no',
      accessor: (row, index) => index + 1,
    },
    {
      Header: 'Course /Program',
      accessor: 'course_cat_name',
      Cell: ({ row }) => (
        <div className='text-left'>{row?.values?.course_cat_name}</div>
      ),
    },
    {
      Header: 'Branch /Combination',
      accessor: 'course_name',
      Cell: ({ row }) => (
        <div className='text-left'>{row?.values?.course_name}</div>
      ),


    },


    {
      Header: "Course Duration",
      accessor: "duration"
    },
    {
      Header: `Intake Approved for ${AC_YEAR_OLD}`,
      accessor: "final_sanction_intake"
    }, {
      Header: "Approved No. of Sections",
      accessor: "approv_no_of_sections"
    }, {
      Header: "If available Please specify the Intake approved by competent Authority",
      accessor: "exst_course_competent_auth_intake_21"
    },
    {
      Header: `Intake being requested by College for this academic year ${acYear}`,
      accessor: "exst_course_requested_intake_21"
    },

  ];








  const AddictionalCourseDtlsColumns = [
    {
      Header: 'Sl.no',
      accessor: (row, index) => index + 1,
    },
    {
      Header: 'Course /Program',
      accessor: 'course_cat_name',
      Cell: ({ row }) => (
        <div className='text-left'>{row?.values?.course_cat_name}</div>
      ),
    },
    {
      Header: 'Branch /Combination',
      accessor: 'course_name',
      Cell: ({ row }) => (
        <div className='text-left'>{row?.values?.course_name}</div>
      ),

    },


    {
      Header: "Course Duration",
      accessor: "duration"
    },
    {
      Header: `Intake Approved for ${AC_YEAR_OLD}`,
      accessor: "final_sanction_intake"
    }, {
      Header: "Approved No. of Sections",
      accessor: "approv_no_of_sections"
    },

    {
      Header: "Additional Number of Sections being requested (other than that are approved)",
      accessor: "addl_course_requested_sections_21"
    },

  ];


  const AdditionalNewCourseColumns = [
    {
      Header: 'Sl.no',
      accessor: (row, index) => index + 1,
    },
    {
      Header: 'Course /Program',
      accessor: 'course_cat_name',
      Cell: ({ row }) => (
        <div className='text-left'>{row?.values?.course_cat_name}</div>
      ),
    },
    {
      Header: 'Branch /Combination',
      accessor: 'course_name',
      Cell: ({ row }) => (
        <div className='text-left'>{row?.values?.course_name}</div>
      ),

    },
    {
      Header: "Course Duration",
      accessor: "duration"
    },
  ];


  // const PermanentCourseDataColumns = [
  //   {
  //     Header: 'Sl.no',
  //     accessor: (row, index) => index + 1,
  //   },
  //   {
  //     Header: 'Course /Program',
  //     accessor: 'course_cat_name',
  //     Cell: ({ row }) => (
  //       <div className='text-left'>{row?.values?.course_cat_name}</div>
  //     ),
  //   },
  //   {
  //     Header: 'Branch /Combination',
  //     accessor: 'course_name',
  //     Cell: ({ row }) => (
  //       <div className='text-left'>{row?.values?.course_name}</div>
  //     ),

  //   },


  //   {
  //     Header: "Course Duration",
  //     accessor: "duration"
  //   },


  // ];


  const WithdrawalcoursesColumns = [
    // {
    //   Header: 'Sl.no',
    //   accessor: (row, index) => index + 1,
    // },
    // {
    //   Header: 'Course /Program',
    //   accessor: 'course_cat_name',
    //   Cell: ({ row }) => (
    //     <div className='text-left'>{row?.values?.course_cat_name}</div>
    //   ),
    // },
    // {
    //   Header: 'Branch /Combination',
    //   accessor: 'course_name',
    //   Cell: ({ row }) => (
    //     <div className='text-left'>{row?.values?.course_name}</div>
    //   ),

    // },


    // {
    //   Header: "Course Duration",
    //   accessor: "duration"
    // },
    ...AdditionalNewCourseColumns,

    {
      Header: "Approved No. of sections",
      accessor: "approv_no_of_sections"
    },

    {
      Header: "No. of Sections being Withdrawn",
      accessor: "withdraw_no_of_sections"
    },


  ];


  return (
    <>
      <CommonFormHeading heading="Application Category Reports" />
      <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <FormikProvider value={affclgcourseDtlsFormik}>
          <Form onChange={affclgcourseDtlsFormik.handleChange} onSubmit={affclgcourseDtlsFormik.handleSubmit} className="form_adjust" >

            <Accordion className='affl-accord'>
              <Accordion.Item eventKey="0" >
                <Accordion.Header >
                  <h7 >1. Renewal of the Affiliation of the Existing courses</h7>
                </Accordion.Header>
                <Accordion.Body>

                  {existingCourses.length > 0 ? (
                    <CommonReactTable data={existingCourses} columns={CourseDetailsColumns} filename="Renewal of the Affiliation of the Existing courses" headerName={`Renewal of the Affiliation of the Existing courses`} />
                  ) : ("No Details Given by the College in Application Category section"
                  )}


                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header >

                  <h7>2.  Additional Sections for Existing Courses</h7>
                </Accordion.Header>
                <Accordion.Body>`
                  {additionalSecData?.length > 0 ? (


                    <CommonReactTable data={additionalSecData} columns={AddictionalCourseDtlsColumns} filename="Additional Sections for Existing Courses" headerName={`Additional Sections for Existing Courses`} />

                  ) : ("No Details Given by the College in Application Category section"
                  )}

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header >

                  <h7>3. Affiliation of Additional Courses</h7>
                </Accordion.Header>
                <Accordion.Body>
                  {additionaNewCourseData.length > 0 ? (

                    <CommonReactTable data={additionaNewCourseData} columns={AdditionalNewCourseColumns} filename="Affiliation of Additional Courses" headerName={`Affiliation of Additional Courses`} />


                  ) : ("No Details Given by the College in Application Category section"
                  )}

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3" >
                <Accordion.Header >

                  <h7>4.Permanent Affiliation of Existing courses</h7>
                </Accordion.Header>
                <Accordion.Body>
                  {withDrawCourseData.length > 0 ? (
                    // PermanentCourseDataColumns
                    <CommonReactTable data={perminantCourseData} columns={AdditionalNewCourseColumns} filename="Permanent Affiliation of Existing courses" headerName={`Permanent Affiliation of Existing courses`} />

                  ) : ("No Details Given by the College in Application Category section")}

                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" >
                <Accordion.Header>

                  <h7>5.Application for Withdrawal of Courses</h7>
                </Accordion.Header>
                <Accordion.Body>

                  {withDrawCourseData.length > 0 ? (
                    <CommonReactTable data={withDrawCourseData} columns={WithdrawalcoursesColumns} filename="Application for Withdrawal of Courses" headerName={`Application for Withdrawal of Courses`} />
                  ) : ("No Details Given by the College in Application Category section")}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>


          </Form>
        </FormikProvider>
      </Container>


    </>
  )
}
